import { useEffect, useState } from "react";

const KEY = "showLabTestsWithoutReadingsInPrint";
const EVENT_NAME = "showLabTestsWithoutReadingsInPrintChanged";

// eslint-disable-next-line import/prefer-default-export
export const useShowLabTestsWithoutReadingsInPrint = (): {
  showLabTestsWithoutReadingsInPrint: boolean;
  setShowLabTestsWithoutReadingsInPrint: (value: boolean) => void;
} => {
  const [showLabTestsWithoutReadingsInPrint, setShowLabTestsWithoutReadingsInPrint] =
    useState<boolean>(() => {
      const stored = localStorage.getItem(KEY);
      return stored === null ? true : stored === "true";
    });

  // use effects
  useEffect(() => {
    localStorage.setItem(KEY, String(showLabTestsWithoutReadingsInPrint));
    window.dispatchEvent(new Event(EVENT_NAME));
  }, [showLabTestsWithoutReadingsInPrint]);

  useEffect(() => {
    const sync = () => {
      setShowLabTestsWithoutReadingsInPrint(localStorage.getItem(KEY) === "true");
    };

    const handleStorage = (e: StorageEvent) => {
      if (e.key === KEY) {
        sync();
      }
    };

    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return { showLabTestsWithoutReadingsInPrint, setShowLabTestsWithoutReadingsInPrint };
};
